import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;

const api = {
  Page: {
    ...apiFuns.genStandard("page", "/api/datacenter"),
    // testSql:(para)=> post('/api/datacenter/dbCon/test', para),
  },
  Role: apiFuns.genStandard("role", "/api/md"),
  Module: apiFuns.genStandard("module", "/api/datacenter")

};

export default api;
